import { jsx as _jsx } from "react/jsx-runtime";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MUISelect from '@material-ui/core/Select';
import cn from 'classnames';
import { testAttr } from '../../helpers';
import useStyles from './Select.styles';
const Select = ({ className, classes: classOverrides = {}, value, disabled = false, fullWidth = false, children, onBlur, onChange = () => { }, onClose, onFocus, onOpen, open, testId, native = true, displayEmpty, renderValue, }) => {
    const classes = useStyles();
    return (_jsx(MUISelect, Object.assign({ MenuProps: {
            classes: {
                paper: classes.menuPaper,
            },
        }, className: cn(classes.root, className), native: native, value: value, disabled: disabled, fullWidth: fullWidth, IconComponent: ExpandMoreIcon, onChange: (e) => onChange(e.target.value), onClose: onClose, onBlur: onBlur, onFocus: onFocus, onOpen: onOpen, open: open, classes: Object.assign(Object.assign({}, classOverrides), { select: cn(classes.select, classOverrides.select), icon: cn(classes.icon, disabled && classes.iconDisabled) }), inputProps: Object.assign({}, testAttr(testId)), displayEmpty: displayEmpty, renderValue: renderValue }, { children: children })));
};
export default Select;
//# sourceMappingURL=Select.js.map